function wrapSections(section_class) {
    var childSections = document.querySelectorAll("." + section_class);
    var wrapper = document.createElement('div');
    wrapper.classList.add(section_class + "-wrapper");
    childSections.item(1).parentNode.insertBefore(wrapper, childSections.item(1));

    for (var i = 1; i < childSections.length; i++) {
        wrapper.appendChild(childSections.item(i));
    }
}
// You can call this function with a specific section class.
wrapSections("grp-bg");
